import React, { Component } from "react";
import { Row, Col, Table } from "reactstrap";
import { api, dateHelper } from "../helpers";
import Alert from "react-s-alert";
import "./Site.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default class ProductInventoryChangeLog extends Component {
  static displayName = ProductInventoryChangeLog.name;
  constructor(props) {
    super(props);
    this.state = {
      productId:
        props.match && props.match.params && props.match.params.productid
          ? props.match.params.productid
          : "",
      loaded: false,
      product: null,
      inventoryChangeLogs: []
    };
    this.loadProductInventoryChangeLog = this.loadProductInventoryChangeLog.bind(
      this
    );
  }

  componentDidMount() {
    this.loadProductInventoryChangeLog();
  }

  loadProductInventoryChangeLog() {
    const errorMessage =
      "There was an error getting the product inventory change log";
    if (!this.state.productId) {
      Alert.error(errorMessage);
      return;
    }

    api
      .fetch(
        `Product/GetProductInventoryChangeLogs?productId=${
          this.state.productId
        }`
      )
      .then(response => {
        if (response && response.data) {
          this.setState({
            product: response.data.product,
            inventoryChangeLogs: response.data.inventoryChangeLogs,
            loaded: true
          });
        } else {
          Alert.error(errorMessage);
          return;
        }
      })
      .catch(x => Alert.error(errorMessage));
  }

  render() {
    return this.state.loaded ? (
      <React.Fragment>
        <Row className="pageTitle p-2">
          <Col className="blueText">
            <h4>
              Product inventory change log for - {this.state.product.name} ({
                this.state.product.sku
              })
            </h4>
          </Col>
        </Row>
        <Row>
          <Col>
            <Table>
              <thead>
                <tr>
                  <th>Changed At</th>
                  <th>Changed By</th>
                  <th>For Demand Report Date</th>
                  <th>New Value</th>
                  <th>Previous Value</th>
                  <th>Is Cycle Count Override</th>
                </tr>
              </thead>
              <tbody>
                {this.state.inventoryChangeLogs &&
                  this.state.inventoryChangeLogs.map((x, index) => (
                    <tr key={index}>
                      <td>{dateHelper.localDateTime(x.createdAt)}</td>
                      <td>{x.changedByFullName}</td>
                      <td>
                        {dateHelper.formatStringDate(
                          x.demandReportDate,
                          "M/D/YYYY"
                        )}
                      </td>
                      <td>{x.newInventoryValue}</td>
                      <td>{x.previousInventoryValue}</td>
                      <td>
                        {x.isCycleCountOverride ? (
                          <FontAwesomeIcon
                            icon="check"
                            className="ml-2 cbdmdBlueText"
                          />
                        ) : null}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </Table>
          </Col>
        </Row>
      </React.Fragment>
    ) : (
      <Row>
        <Col>
          <h5>Loading product inventory change log...</h5>
        </Col>
      </Row>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ProductInventoryChangeLog.js